import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-schedule",
  templateUrl: "./med-icon-view-schedule.component.html",
})
export class MedIconViewScheduleComponent extends SvgMixinComponent {}
